import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import money from "../../../assets/icons/moneybag.svg";

const Categories = () => {
  return (
    <Box
      margin={{ xs: "25% 0% 15% 0%", sm: "5% 0% 10% 0%" }}
      data-aos={"fade-down"}
    >
      <Box>
        <Typography
          variant="h3"
          fontWeight={700}
          textAlign={"center"}
          paddingBottom={{ xs: "6%", sm: "4%" }}
          color={"#39484E"}
        >
          Investment Categories
        </Typography>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          flexWrap={"wrap"}
        >
          <Box
            width={{ xs: "100%", sm: "50%" }}
            paddingRight={{ xs: "0%", sm: "4%" }}
          >
            <Typography
              variant="h4"
              color={"#39484E"}
              paddingBottom={{ xs: "6%", sm: "4%" }}
              fontWeight={700}
              textAlign={"center"}
            >
              Seed Grants
            </Typography>
            <Box marginBottom={"4%"} display={"flex"} justifyContent={"center"}>
              {" "}
              <Box
                component="img"
                height={{ xs: "54px", sm: "84px" }}
                sx={{
                  objectFit: "cover",
                  overflow: "hidden",
                  width: "16%",
                }}
                src={money}
                alt={"icons"}
              />
            </Box>
            <Typography
              variant="h5"
              color={"#39484E"}
              paddingBottom={{ xs: "6%", sm: "4%" }}
              fontWeight={700}
              textAlign={"center"}
            >
              $15,000 to $50,000
            </Typography>
            <Divider />
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              padding={{ xs: "6% 0%", sm: "4% 0%" }}
            >
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Designed to support early-stage ideas and emerging projects.
            </Typography>
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              paddingBottom={{ xs: "4%", sm: "2%" }}
            >
              {" "}
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Targets initiatives with potential but lacking proof of concept,
              funding, or infrastructure.
            </Typography>
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              paddingBottom={{ xs: "4%", sm: "2%" }}
            >
              {" "}
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Focuses on community-based ideas that can evolve into
              transformative solutions.
            </Typography>
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              paddingBottom={{ xs: "4%", sm: "2%" }}
            >
              {" "}
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Requires a clear problem statement, proposed solution, and early
              impact goals (e.g., participant reach, ESG improvements).
            </Typography>
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              paddingBottom={{ xs: "4%", sm: "2%" }}
            >
              {" "}
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Includes monitoring and evaluation, with potential for additional
              funding upon milestone achievement.
            </Typography>
          </Box>
          <Box
            width={{ xs: "100%", sm: "50%" }}
            paddingRight={{ xs: "0%", sm: "4%" }}
            paddingBottom={{ xs: "20%", sm: "0%" }}
          >
            <Typography
              variant="h4"
              color={"#39484E"}
              paddingBottom={{ xs: "6%", sm: "4%" }}
              paddingTop={{ xs: "25%", sm: "2%" }}
              fontWeight={700}
              textAlign={"center"}
            >
              Growth-Stage Grants
            </Typography>
            <Box marginBottom={"4%"} display={"flex"} justifyContent={"center"}>
              {" "}
              <Box
                component="img"
                height={{ xs: "54px", sm: "84px" }}
                sx={{
                  objectFit: "cover",
                  overflow: "hidden",
                  width: "16%",
                }}
                src={money}
                alt={"icons"}
              />
            </Box>
            <Typography
              variant="h5"
              color={"#39484E"}
              paddingBottom={{ xs: "6%", sm: "4%" }}
              fontWeight={700}
              textAlign={"center"}
            >
              $50,000 to $150,000
            </Typography>
            <Divider />
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              padding={{ xs: "6% 0%", sm: "4% 0%" }}
            >
              {" "}
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Supports projects with proof of concept and demonstrated impact.
            </Typography>
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              paddingBottom={{ xs: "4%", sm: "2%" }}
            >
              {" "}
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Aimed at scaling operations, improving infrastructure, or
              replicating successful models.
            </Typography>
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              paddingBottom={{ xs: "4%", sm: "2%" }}
            >
              {" "}
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Focuses on accelerating proven solutions for systemic impact on
              larger populations or areas.
            </Typography>
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              paddingBottom={{ xs: "4%", sm: "2%" }}
            >
              {" "}
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Prioritizes organizations with strong governance, measurable
              social impact, and clear scaling pathways.
            </Typography>
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              paddingBottom={{ xs: "4%", sm: "2%" }}
            >
              {" "}
              <Typography component={"span"} color={"#948979"} fontWeight={600}>
                &#10004;{" "}
              </Typography>
              Encourages partnerships with local governments and community
              stakeholders.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Categories;
